<app-loader [isLoading]="isLoading"></app-loader>

<!-- Sync Progress Overlay -->
@if (isSyncing) {
<div class="sync-overlay">
  <div class="sync-content">
    <img src="img/serveto-black.png" alt="Serveto" class="sync-logo">
    <div class="sync-info">
      @if (syncProgress) {
      <p class="sync-text">
        Sincronizando semana {{ syncProgress.current_week || '...' }}/{{ syncProgress.total_weeks }}
        ({{ syncProgress.progress_percent | number:'1.0-0' }}%)
      </p>
      <mat-progress-bar mode="determinate" [value]="syncProgress.progress_percent">
      </mat-progress-bar>
      @if (syncProgress.failed_weeks > 0) {
      @if (syncProgress.failed_weeks == 1) {
      <p class="sync-warning">{{ syncProgress.failed_weeks }} semana fallida</p>
      } @else {
      <p class="sync-warning">{{ syncProgress.failed_weeks }} semanas fallidas</p>
      }
      }
      } @else {
      <p class="sync-text">Iniciando sincronización...</p>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>
  </div>
</div>
}

<!-- Sync Error Message -->
<!-- @if (syncError) {
<div class="sync-error-banner">
  <div class="sync-error-content">
    <mat-icon>error</mat-icon>
    <span>{{ syncError }}</span>
    <button mat-icon-button (click)="dismissSyncError()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
} -->

<div class="header">
  <div class="top">
    <a routerLink="/home/vacations/drivers/exercise/{{ id }}/{{ year }}">
      <h3>Tetris / Ejercicio {{ year }}/</h3>
      <div class="breadcrumb">
        <mat-icon svgIcon="arrow back"></mat-icon>
        <h2>{{ operativeGroup?.name }}</h2>
      </div>
      <!-- <div class="subtitle background">
        <mat-icon>check_circle</mat-icon>
        Período de vacaciones <strong>inicial</strong> activo (01/08/2026 -
        08/08/2026)
      </div> -->
    </a>
    <div class="boton">
      <!-- <button class="b2" mat-icon-button (click)="reloadData()"><mat-icon>refresh</mat-icon></button> -->
      <!-- <button class="b1" mat-button>Editar protocolo</button> -->
      <button class="b1" mat-button (click)="syncWeeksManually()">Sincronizar calendario</button>
      <button class="b1" mat-button [routerLink]="[
        '/home/vacations/drivers/exercise',
        id,
        year,
        'operational',
        operativeGroup?.id,
        'edit'
      ]">
        Editar operativa
      </button>
      <button class="b1" mat-button [routerLink]="[
        '/home/vacations/drivers/exercise',
        id,
        year,
        'operational',
        operativeGroup?.id,
        'edit-holidays'
      ]">Editar festivos</button>
    </div>
  </div>

  <div class="header-cards">
    <!-- TODO: Hacer componente de card -->
    <div class="card">
      <div class="title">CAMIONES DISPONIBLES</div>
      <div class="numbers">
        <!-- <mat-icon id="check">check_circle</mat-icon>
        <mat-icon>error</mat-icon> -->
        <span>{{ operativeGroup?.total_trucks}}</span>
      </div>
    </div>

    <div class="card">
      <div class="title">CHÓFERES DISPONIBLES</div>
      <div class="numbers">
        <!-- <mat-icon id="check">check_circle</mat-icon>
        <mat-icon>error</mat-icon> -->
        <span>{{ operativeGroup?.total_drivers}}</span>
      </div>
    </div>
  </div>
</div>

<div class="content">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="CALENDARIO">
      <div class="calendar">
        <mat-form-field appearance="outline" style="width: 250px;">
          <mat-label>Semana</mat-label>
          <mat-select [formControl]="weekFilter" placeholder="Selecciona una semana">
            @for (week of weekList; track week.value) {
            <mat-option [value]="week.value">{{ week.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <app-horizontal-calendar [weeks]="calendarWeeks" [isLoading]="isLoadingCalendar"
          [refreshingWeekNumber]="refreshingWeekNumber" [operativaGroupId]="operativeGroup?.id" [exerciseId]="id"
          [year]="year" [operativaGroupName]="operativeGroup?.name" (refreshWeek)="onRefreshWeek($event)"
          (weekUpdated)="onWeekUpdated()" (exportLoading)="onExportLoading($event)">
        </app-horizontal-calendar>
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-badge-label">
          PETICIONES PENDIENTES
          <!-- @if ((operativeGroup?.petitions ?? 0) > 0) {
            <span class="petition-badge">{{ operativeGroup?.petitions }}</span>
          } -->
        </span>
      </ng-template>
      <app-petitions [onlyPetitions]="true" [operativeGroupId]="operativeGroup?.id" [exerciseId]="id"
        [reloadFlag]="reloadFlag"></app-petitions>
    </mat-tab>

    <mat-tab label="CHÓFERES">
      <app-petitions [onlyPetitions]="false" [operativeGroupId]="operativeGroup?.id" [exerciseId]="id"
        [reloadFlag]="reloadFlag"></app-petitions>
    </mat-tab>

    <!-- <mat-tab label="PROTOCOLOS"> </mat-tab> -->
  </mat-tab-group>
</div>